import React from "react";

const PrivacyPolicy = () => {
  return (
    <div className="p-6 max-w-4xl mx-auto">
      <h1 className="text-3xl font-bold mb-4">Privacy Policy</h1>
      <p className="mb-4">
        This Privacy Policy describes how we collect, use, and protect the
        personal information you provide when using our app.
      </p>

      <h2 className="text-2xl font-semibold mt-6 mb-2">
        1. Information We Collect
      </h2>
      <ul className="list-disc pl-6 mb-4">
        <li>
          <strong>Email address and password:</strong> Used for user
          authentication.
        </li>
        <li>
          <strong>Name:</strong> Used to identify the user within the app.
        </li>
        <li>
          <strong>Checklist responses:</strong> Includes any text or image
          uploads submitted as part of completing checklists.
        </li>
        <li>
          <strong>Device identifiers:</strong> May be collected anonymously for
          analytics and crash reporting (if applicable).
        </li>
      </ul>

      <h2 className="text-2xl font-semibold mt-6 mb-2">
        2. How We Use Your Information
      </h2>
      <ul className="list-disc pl-6 mb-4">
        <li>To authenticate and manage user access.</li>
        <li>To allow users to complete and submit assigned checklists.</li>
        <li>
          To store checklist answers (including uploaded images) securely.
        </li>
        <li>To improve app functionality and stability.</li>
      </ul>

      <h2 className="text-2xl font-semibold mt-6 mb-2">3. Data Security</h2>
      <p className="mb-4">
        All data is encrypted in transit using secure protocols (e.g., HTTPS).
        We implement appropriate security measures to protect against
        unauthorized access or disclosure.
      </p>

      <h2 className="text-2xl font-semibold mt-6 mb-2">4. Data Sharing</h2>
      <p className="mb-4">
        We do not share your personal information with third parties except as
        required to operate the app (e.g., cloud storage providers such as
        Firebase or AWS).
      </p>

      <h2 className="text-2xl font-semibold mt-6 mb-2">5. Data Retention</h2>
      <p className="mb-4">
        Your data is retained as long as your account is active or as needed to
        provide our services. You may request deletion of your data at any time.
      </p>

      <h2 className="text-2xl font-semibold mt-6 mb-2">6. User Rights</h2>
      <ul className="list-disc pl-6 mb-4">
        <li>
          You can request to access, update, or delete your personal data.
        </li>
        <li>
          To make a request, please contact us at{" "}
          <a
            href="mailto:info@logic-services.com"
            className="text-blue-600 underline"
          >
            info@logic-services.com
          </a>
          .
        </li>
      </ul>

      <h2 className="text-2xl font-semibold mt-6 mb-2">7. Contact Us</h2>
      <p className="mb-4">
        If you have any questions about this Privacy Policy, please contact us
        at{" "}
        <a
          href="mailto:info@logic-services.com"
          className="text-blue-600 underline"
        >
          info@logic-services.com
        </a>
        .
      </p>

      <p className="text-sm text-gray-500 mt-8">Last updated: July 3, 2025</p>
    </div>
  );
};

export default PrivacyPolicy;
